
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[brand]/product/[slug]",
      function () {
        return require("private-next-pages/[brand]/product/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[brand]/product/[slug]"])
      });
    }
  